<template>
    <ReviewQuoteBlock
        v-if="review"
        :property="review?.property?.[0]"
    >
        <template
            v-if="review?.author"
            #author
        >
            {{ review?.author }}
        </template>

        <template
            v-if="review?.date"
            #date
        >
            {{ format(review?.date, 'dd-MM-yyyy') }}
        </template>

        <template 
            v-if="review?.quote" 
            #default
        >
            {{ review?.quote }}
        </template>

        <template
            v-if="review?.score"
            #score
        >
            <BaseReviewStars :rating="Number(review?.score)" />
        </template>

        <template
            v-if="review?.property?.[0]"
            #property
        >
            {{ review?.property?.[0]?.title }}
        </template>
    </ReviewQuoteBlock>
</template>

<script setup>
import { format } from 'date-fns';

defineProps({
    review: {
        type: Object,
        required: true,
        default: () => {}
    }
});
</script>
